import { cn } from "@/lib/utils";
import React from "react";

interface TypoProps extends React.HTMLAttributes<HTMLElement> {
  variant?:
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "p"
    | "blockquote"
    | "inlineCode"
    | "muted"
    | "xsmall"
    | "small";
  className?: string;
  children: React.ReactNode;
}

const variantMap = {
  h1: {
    tag: 'h1',
    className: 'scroll-m-20 text-center text-4xl font-extrabold tracking-tight text-balance line leading-tight',
  },
  h2: {
    tag: 'h2',
    className: 'scroll-m-20 pb-2 text-3xl font-semibold tracking-tight first:mt-0 leading-tight',
  },
  h3: {
    tag: 'h3',
    className: 'scroll-m-20 text-xl md:text-2xl font-semibold tracking-tight leading-tight',
  },
  h4: {
    tag: 'h4',
    className: 'scroll-m-20 text-lg md:text-xl font-semibold tracking-tight leading-tight',
  },
  h5: {
    tag: 'h5',
    className: 'scroll-m-20 text-lg font-semibold tracking-tight leading-tight',
  },
  h6: {
    tag: 'h6',
    className: 'scroll-m-20 text-base tracking-tight leading-tight',
  },
  p: {
    tag: 'p',
    className: 'leading-7 [&:not(:first-child)]:mt-6',
  },
  blockquote: {
    tag: 'blockquote',
    className: 'mt-6 border-l-2 pl-6 italic',
  },
  inlineCode: {
    tag: 'code',
    className: 'bg-muted relative rounded px-[0.3rem] py-[0.2rem] font-mono text-sm font-semibold',
  },
  muted: {
    tag: 'p',
    className: 'text-muted-foreground text-sm',
  },
  small: {
    tag: 'small',
    className: 'text-sm',
  },
  xsmall: {
    tag: 'small',
    className: 'text-muted-foreground text-xs',
  },
};

export function Typo({ variant = "p", className = "", children, ...props }: TypoProps) {
  const { tag, className: variantClass } = variantMap[variant] || variantMap.p;
  return React.createElement(
    tag,
    { className: cn(variantClass, className), ...props },
    children
  );
}
